import { ActionTree } from 'vuex'
import { SubscriptionState } from './types'
import { RootState } from '../types'
import { SubscriptionsHelpers } from '@/helpers/mainExports.js'

export const actions: ActionTree<SubscriptionState, RootState> = {
  addThingSubscription({ commit }, payload) {
    commit('addThingSubscription', payload)
  },
  removeSubscriptionFromState({ commit }, subscriptionId) {
    commit('removeSubscriptionFromState', subscriptionId)
  },
  cleanSubscriptionState({ commit }) {
    commit('cleanSubscriptionState')
  },
  unsubscribeThingsTopicUpdate(): Promise<void> {
    return new Promise(async resolve => {
      const subscriptions = SubscriptionsHelpers.getSubscriptionsFromTopic()
      await SubscriptionsHelpers.unsubscribeAll(subscriptions)
      resolve()
    })
  }
}
